export enum SubLocations {
  Step1 = 'Step 1',
  Step2 = 'Step 2',
  Step3 = 'Step 3',
  Step4 = 'Step 4',
  ExistingAccountSection = 'existing account section'
}
